import { render, staticRenderFns } from "./SaleReceipt.vue?vue&type=template&id=6bee3cfa&scoped=true"
import script from "./SaleReceipt.vue?vue&type=script&lang=js"
export * from "./SaleReceipt.vue?vue&type=script&lang=js"
import style0 from "./SaleReceipt.vue?vue&type=style&index=0&id=6bee3cfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bee3cfa",
  null
  
)

export default component.exports